import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { isLegacyPath } from "@/lib/theme";
import { PUBLIC_PREFIXES } from "@/components/shell/navConfig";

export const useShellActive = () => {
  const { user, apps } = useAuth();
  const { pathname } = useLocation();
  const internal = user?.role === "admin" || (apps || []).some((a) => !a.benefit_ets);
  const isPublic = pathname === "/" || PUBLIC_PREFIXES.some((p) => pathname.startsWith(p));
  return Boolean(user && user.user_id && internal && !isPublic && !isLegacyPath(pathname));
};
